import { useEffect, useState } from "react";
import { _BusinessProcess, _HelpDesk, _Inbox, _single, _SystemPropertyOB } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import useModal, { MODAL_md } from "../../../hooks/useModal";
import { Modal } from "../../../Modal";
import { toast } from "react-toastify";
import { PrintJson } from "../../../PrintJson";
import { HelpdeskBPM } from "./Supports/HelpdeskBPM";
import { IncidentSupport } from "./Supports/IncidentSupport";

type SupportType = "BPM" | "INCIDENT";

export const HelpButtom = () => {

    const { instance } = useDataBean(_SystemPropertyOB);

    const [bpmSupport, setBpmSupport] = useState<boolean>(false);
    const [onSubmitChild, setOnSubmitChild] = useState<null | (() => void)>(null);
    const [supportType, setSupportType] = useState<SupportType>("INCIDENT");

    const modal = useModal("Solicitar Soporte", MODAL_md)

    useEffect(() => {
        instance.getSystemProperty("Help_Desk_Module")
            .then((resp) => {
                const value = resp.SystemValue === "true";
                if(resp.SystemValue === "true"){
                    setSupportType("BPM")
                }
                setBpmSupport(value);
            })
            .catch(() => {
                toast.error("No se pudieron cargar las propiedades del sistema");
            });
    }, []);



    const solicitar = () => {
        modal.open();
    }



    return (
        <>
            <button title="Mesa de Ayuda" type="button" onClick={solicitar} className="btn btn-icon cursor btn-topbar btn-ghost-secondary rounded-circle light-dark-mode shadow-none">
                <i className="ri-customer-service-2-fill fs-22"></i>
            </button>
            <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={onSubmitChild ?? (() => { })} onSubmitLabel="Solicitar">
                {bpmSupport && (
                    <div className="row mb-3">
                        <div className="col-12 d-flex gap-2 justify-content-around">
                            <button className={`btn ${supportType === "BPM" ? "btn-primary" : "btn-outline-primary"}`} onClick={() => setSupportType("BPM")} >
                                Mesa de Ayuda
                            </button>

                            <button className={`btn ${supportType === "INCIDENT" ? "btn-primary" : "btn-outline-primary"}`} onClick={() => setSupportType("INCIDENT")} >
                                Soporte ERP
                            </button>
                        </div>
                    </div>
                )}


                {bpmSupport ? (
                    supportType === "BPM" ? (
                        <HelpdeskBPM onSubmitClose={() => { modal.close() }} setOnSubmit={setOnSubmitChild} />
                    ) : (
                        <IncidentSupport onSubmitClose={() => { modal.close() }} setOnSubmit={setOnSubmitChild} />
                    )
                ) : (
                    <IncidentSupport onSubmitClose={() => { modal.close() }} setOnSubmit={setOnSubmitChild} />
                )}
            </Modal>

        </>
    )
}